module.exports = __webpack_public_path__ + "img/title2.d2a8d3eb.svg";